/**
 * app.config.ts
 * Centralized application configuration
 */
import { getEnv } from '../utils/envHelper';

export const APP_CONFIG = {
  // Font loading
  FONT_LOAD_TIMEOUT: 10000, // 10 seconds
  GOOGLE_FONTS_API_KEY: getEnv('VITE_GOOGLE_FONTS_API_KEY', ''),

  // Template service
  TEMPLATE_BASE_URL: getEnv('VITE_TEMPLATE_BASE_URL', '/templates'),

  // Backend API
  API_BASE_URL: getEnv('VITE_API_BASE_URL', 'http://localhost:3000/api'),

  // Mode de stockage: 'backend' | 'offline' | 'auto'
  // 'backend': Utilise uniquement le backend API
  // 'offline': Utilise uniquement localStorage
  // 'auto': Essaie le backend, fallback sur localStorage si échec
  STORAGE_MODE: getEnv('VITE_STORAGE_MODE', 'auto'),

  // Request timeout (10 secondes)
  REQUEST_TIMEOUT: 10000,

  // Canvas defaults
  DEFAULT_CANVAS_WIDTH: 800,
  DEFAULT_CANVAS_HEIGHT: 600,
  DEFAULT_BACKGROUND_COLOR: '#ffffff',
  DEFAULT_GRID_SIZE: 20,

  // Performance
  MAX_HISTORY_STATES: 50,
  AUTO_SAVE_INTERVAL: 30000, // 30 seconds
  CACHE_CLEANUP_INTERVAL: 300000, // 5 minutes

  // Storage
  MAX_PROJECTS: 100,
  STORAGE_LIMIT: 100 * 1024 * 1024, // 100MB

  // UI
  ANIMATION_DURATION: 200,
  DEBOUNCE_DELAY: 300,
  THROTTLE_DELAY: 100,

  // Export
  DEFAULT_EXPORT_QUALITY: 1,
  DEFAULT_EXPORT_PIXEL_RATIO: 2,
  MAX_EXPORT_WIDTH: 10000,
  MAX_EXPORT_HEIGHT: 10000,
} as const;

export type AppConfig = typeof APP_CONFIG;
